// extracted by mini-css-extract-plugin
export default {"container":"data_container__TCWH0","addNoteButton":"data_addNoteButton__VYnET","container2":"data_container2__kugzR"};